import { useEffect, useState } from "react";
import { Container, FormLabel, Button, Modal, Row, Col, FormControl, Tooltip, OverlayTrigger, ModalTitle, Alert } from "react-bootstrap";
import { GiBrickWall } from "react-icons/gi";
import { Stage, Layer, Rect, Text, Arrow, Group } from 'react-konva';
import { AllCabinetConfigs } from "./BaseCabinets";
import { globalinchtopointfactor, globalwallx, globalwally } from "./AuxiliaryFunctions";
import { MdAddCircle, MdDeleteForever, MdEditSquare } from "react-icons/md";
import MessageBox from './MessageBox';

let inchtopointfactor = globalinchtopointfactor;
const wallx = globalwallx;
const wally = globalwally;

const InsertOrEditCurrentWall = (props) => {

  const mode = props.mode; // 0 (create) or 1 (edit)
  const currentWallIndex = props.currentWallIndex; // the index of the current wall  
  const totalwalls = props.totalwalls;
  // absolute orientation of the current wall in the top view (derived by the
  // parent from the walls themselves - it used to be an accumulated
  // "sumOfAngles" state that went out of sync with the real layout).
  const currentWallAngle = parseInt(props.currentWallAngle, 10) || 0;
  const zeroIndex = props.zeroIndex; // the index of the initial wall
  
  const stagewidth = 250;
  const stageheight = 200;

  let xinitialwallloc = 0; 
  let yinitialwallloc = 0;
  let rowx1, rowx2, rowy1, rowy2;

  const widthttopwallloc = 100;   // length of the wall in the preview
  const heighttopwallloc = 8;     // thickness of the wall in the preview
  xinitialwallloc = (stagewidth - widthttopwallloc)/2;
  yinitialwallloc = stageheight/2;
  
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');  

  const [defaultSide, setDefaultSide] = useState('right'); // 'right' or 'left'
  const [lgShow, setLgShow] = useState(false);
  const [currentWall, setCurrentWall] = useState(props.mode===0?{}:props.walls[props.currentWallIndex]); //useState(props.mode===0?{}:props.wall);
  const [leftCornerEnd, setLeftCornerEnd] = useState("FillerEndPanel");
  const [rightCornerEnd, setRightCornerEnd] = useState("FillerEndPanel");
  const [wallleftCornerEnd, setWallLeftCornerEnd] = useState("FillerEndPanel");
  const [wallrightCornerEnd, setWallRightCornerEnd] = useState("FillerEndPanel");  
  const [widthDifference, setWidthDifference] = useState(0);
  const [baseLeftCornerSelectEnabled, setBaseLeftCornerSelectEnabled] = useState(true);
  const [wallLeftCornerSelectEnabled, setWallLeftCornerSelectEnabled] = useState(true);
  const [baseRightCornerSelectEnabled, setBaseRightCornerSelectEnabled] = useState(true);
  const [wallRightCornerSelectEnabled, setWallRightCornerSelectEnabled] = useState(true);

  const [LabelForNoCornerLeftCabinet, setLabelForNoCornerLeftCabinet] = useState("");
  const [LabelForNoCornerRightCabinet, setLabelForNoCornerRightCabinet] = useState("");  

  // ---------------------------------------------------------------------------
  // Geometry of the preview of the new wall (local coordinates of the group:
  // the current wall goes to the right from (-L/2,0) to (L/2,0)).
  // ---------------------------------------------------------------------------
  const newWallDirection = parseInt(currentWall.walldirection, 10) || 90;
  const previewNewWallRect = (() => {
    const L = widthttopwallloc;
    const t = heighttopwallloc;
    const rad = (newWallDirection * Math.PI) / 180;
    const dir = { x: Math.round(Math.cos(rad)), y: Math.round(Math.sin(rad)) };
    if (defaultSide === 'right') {
      // inserted to the right: the chain continues at the right end
      return { x: L/2, y: 0, width: L, height: t, rotation: newWallDirection, offset: {x:0, y:t} };
    }
    // inserted to the left: the wall grows from the left end towards `dir`,
    // but the chain walks it in the opposite sense.
    return {
      x: -L/2 + L*dir.x,
      y: 0 + L*dir.y,
      width: L,
      height: t,
      rotation: newWallDirection + 180,
      offset: {x:0, y:t},
    };
  })();

  const handleClose = () => setLgShow(false);
  const handleShow = () => {
    console.log(props);
    console.log(currentWall);

    if (mode === 0) {      
      setCurrentWall({...currentWall, walldirection: 90, wallheight: 95, wallwidth: 110, wallname: "New wall", wallsoftheight:10});
      // (the inputs below are controlled, so the form now shows exactly these
      //  values - it used to display 80 / an empty name while creating a
      //  110 in wall called "New wall")
      setDefaultSide((currentWallIndex ===totalwalls-1)?'right':'left');
      DisableOrDisableDropdown({ mode, currentWallIndex, wall:props.wall, walls: props.walls });

    }
    else {
      console.log(props.walls);
      console.log(currentWall);
      console.log(props.wall);
      // 
      setCurrentWall(props.wall);

      // monitor this change over time and make sure it works in all cases
      //const lc = currentWall.rectangles.find(item => item.shapename === "left_corner").cabinetConfig;
      //const wlc = currentWall.wallrectangles.find(item => item.shapename === "left_corner").cabinetConfig;
      
      //// commenting this for testing, uncomment if problems arise.
      /*
      const lc = props.walls[props.currentWallIndex].rectangles.find(item => item.shapename === "left_corner").cabinetConfig;
      const wlc = props.walls[props.currentWallIndex].wallrectangles.find(item => item.shapename === "left_corner").cabinetConfig;      
      setLeftCornerEnd(lc);
      setWallLeftCornerEnd(wlc);
      */
      
      // monitor this change over time and make sure it works in all cases
      //const rc = currentWall.rectangles.find(item => item.shapename === "right_corner").cabinetConfig;
      //const wrc = currentWall.wallrectangles.find(item => item.shapename === "right_corner").cabinetConfig;
      
      //// commenting this for testing, uncomment if problems arise.
      /*
      const rc = props.walls[props.currentWallIndex].rectangles.find(item => item.shapename === "right_corner").cabinetConfig;
      const wrc = props.walls[props.currentWallIndex].wallrectangles.find(item => item.shapename === "right_corner").cabinetConfig;      
      setRightCornerEnd(rc);      
      setWallRightCornerEnd(wrc);    
      */

      DisableOrDisableDropdown({ mode, currentWallIndex, wall:props.wall, walls: props.walls });
    }

    setLgShow(true);  
  }

  switch (defaultSide) {
    case 'right':
      rowx1 = widthttopwallloc/2;
      rowy1 = 50;
      rowx2 = widthttopwallloc/2;
      rowy2 = 20;
      break;
    case 'left':
      rowx1 = widthttopwallloc/2;
      rowy1 = 50;
      rowx2 = widthttopwallloc/2;
      rowy2 = 20;
      break;      
  }     

  // BUGFIX: parseFloat("") is NaN, which used to travel into the wall and
  // produced walls without geometry. Keep an empty string instead and
  // validate when saving.
  const numericValue = (raw) => {
    const v = parseFloat(raw);
    return Number.isNaN(v) ? '' : v;
  };

  const onChangeCurrentWallHeight = (e) => {
    setCurrentWall({...currentWall, wallheight: numericValue(e.target.value)});
  };

  const onChangeCurrentWallWidth = (e) => {
    setCurrentWall({...currentWall, wallwidth: numericValue(e.target.value)});
  };  

  const onChangeCurrentWallSofheight = (e) => {
    setCurrentWall({...currentWall, wallsoftheight: numericValue(e.target.value)});
  };  

  const onChangeCurrentWallName = (e) => {
    setCurrentWall({...currentWall, wallname: e.target.value});
  };    

  // I don't think this is used
  const onChangeCurrentWallDirection = (e) => {
    if ((parseInt(currentWallIndex) === parseInt(zeroIndex)) && (mode===1)) {

    }
    else {
      setCurrentWall({...currentWall, walldirection: parseInt(e.target.value)});
    }    
  };  

  const onChangeCurrentWallSide = (e) => {
    setDefaultSide(e.target.value);
  };    

  const onChangeCurrentWallIndex = (e) => {
    setCurrentWall({...currentWall, wallindex: e.target.value});
  };

  const onSaveWall = () => { 
    // the wall needs a usable size
    const widthOk = parseFloat(currentWall.wallwidth) > 0;
    const heightOk = parseFloat(currentWall.wallheight) > 0;
    if (!widthOk || !heightOk) {
      setErrmessage("Please enter a width and a height greater than 0 for the wall.");
      setShowerror(true);
      return;
    }
    let corner_side = defaultSide + "_corner";
    const wall_no_corner = props.walls[currentWallIndex].wallrectangles.some(
      rect => rect.cabinetConfig === "NoCornerCabinet" && rect.shapename === corner_side
    );
    const base_no_corner = props.walls[currentWallIndex].rectangles.some(
      rect => (rect.cabinetConfig === "NoCornerCabinet")
    );

    console.log("logs here");
    console.log(props.currentWallIndex);
    console.log(defaultSide);
    console.log(wall_no_corner);
    console.log(base_no_corner);
    console.log(props.wall.rectangles[1].cabinetConfig, "NoCornerCabinet");
    console.log(props.wall.rectangles[1].cabinetConfig==="NoCornerCabinet");
    console.log(LabelForNoCornerLeftCabinet);
    console.log(LabelForNoCornerRightCabinet);
    console.log(mode);

    var updt_right_adjacent_corners = false;
    var updt_left_adjacent_corners = false;

    if (props.mode === 0) { // the user wants to insert a new wall
      console.log(wall_no_corner, base_no_corner);
      if (wall_no_corner || base_no_corner) {
        setErrmessage("Cannot insert a wall due to the selected option for corner.");
        setShowerror(true);
        return;
      };
    }
    else { // the user wants to edit the current wall
      if (props.currentWallIndex+1 !== props.walls.length) { // there is a wall at the right
        if (LabelForNoCornerRightCabinet) {
          setErrmessage("Cannot set option for no corner cabinet. There is already a wall to the right.");
          setShowerror(true);
          return;
        };
        console.log(props.currentWallIndex, zeroIndex);
        if (props.currentWallIndex >= zeroIndex) {
          updt_left_adjacent_corners = true;      
        }
        
      }

      if (props.currentWallIndex !== 0) { // there is a wall to the left
        if (LabelForNoCornerLeftCabinet) {
          setErrmessage("Cannot set option for no corner cabinet. There is already a wall to the left.");
          setShowerror(true);
          return;
        };
        if (props.currentWallIndex <= zeroIndex) {
          updt_right_adjacent_corners = true;
        }
      }
    }

    const xleft = wallx;

    console.log(leftCornerEnd);

    let cornerCabinetConfig = AllCabinetConfigs.find(config => config.configid === leftCornerEnd);
    let prevCornerCabinetConfig = props.wall.rectangles.find(rect => rect.shapename === "left_corner");    
    //it doesn't work//let prevCornerCabinetConfig = props.walls[props.currentWallIndex].rectangles.find(rect => rect.shapename === "left_corner");    

    let sameConfig = cornerCabinetConfig.configid===prevCornerCabinetConfig.cabinetConfig;
    console.log(sameConfig);
    let previousBaseLeftCornerWidth = prevCornerCabinetConfig.width;

    const yval = inchtopointfactor*currentWall.wallheight + wally - inchtopointfactor*34.5;    

    const leftcornercab = {
      x: xleft,
      y: yval,
      width: (sameConfig)?prevCornerCabinetConfig.width:inchtopointfactor*cornerCabinetConfig.widthMin,
      height: (!sameConfig || (mode===0))?inchtopointfactor*34.5:prevCornerCabinetConfig.height,
      fill: "Gray",
      id: Date.now().toString(), // unique ID
      cabinettype: "base_cabinet",
      shapename: "left_corner",
      selected: false,
      cabinetConfig: cornerCabinetConfig.configid,            
      cornerside: cornerCabinetConfig.cornerside,            
    };

    cornerCabinetConfig = AllCabinetConfigs.find(config => config.configid === rightCornerEnd);    
    prevCornerCabinetConfig = props.wall.rectangles.find(rect => rect.shapename === "right_corner");       
    sameConfig = cornerCabinetConfig.configid===prevCornerCabinetConfig.cabinetConfig;  

    console.log(sameConfig);
    console.log(prevCornerCabinetConfig);

    const xright = inchtopointfactor*currentWall.wallwidth + wallx - (sameConfig?prevCornerCabinetConfig.width:inchtopointfactor*cornerCabinetConfig.widthMin);

    let rightcornercab = {... leftcornercab};
    rightcornercab.x = xright;
    rightcornercab.width = sameConfig?prevCornerCabinetConfig.width:inchtopointfactor*cornerCabinetConfig.widthMin;
    rightcornercab.height = (!sameConfig || (mode===0))?inchtopointfactor*34.5:prevCornerCabinetConfig.height;
    rightcornercab.shapename = "right_corner";
    rightcornercab.cabinetConfig = cornerCabinetConfig.configid;                
    rightcornercab.id = (Date.now()+150).toString(); // unique ID
    rightcornercab.cornerside = cornerCabinetConfig.cornerside;  
    
    cornerCabinetConfig = AllCabinetConfigs.find(config => config.configid === wallleftCornerEnd);
    prevCornerCabinetConfig = props.wall.wallrectangles.find(rect => rect.shapename === "left_corner");
    sameConfig = cornerCabinetConfig.configid===prevCornerCabinetConfig.cabinetConfig;

    let previousWallLeftCornerWidth = prevCornerCabinetConfig.width;    

    const wallleftcornercab = {
      x: xleft,
      y: wally + inchtopointfactor*currentWall.wallsoftheight,
      width: sameConfig?prevCornerCabinetConfig.width:inchtopointfactor*cornerCabinetConfig.widthMin,
      //height: sameConfig?prevCornerCabinetConfig.height:inchtopointfactor*cornerCabinetConfig.allowedHeights[0],
      height: (!sameConfig || (mode===0))?inchtopointfactor*cornerCabinetConfig.allowedHeights[0]:prevCornerCabinetConfig.height,
      fill: "Gray",
      id: Date.now().toString()+180, // unique ID
      cabinettype: "wall_cabinet",
      shapename: "left_corner",
      selected: false,
      cabinetConfig: cornerCabinetConfig.configid,            
      cornerside: cornerCabinetConfig.cornerside,   
    };

    cornerCabinetConfig = AllCabinetConfigs.find(config => config.configid === wallrightCornerEnd);
    prevCornerCabinetConfig = props.wall.wallrectangles.find(rect => rect.shapename === "right_corner");
    sameConfig = cornerCabinetConfig.configid===prevCornerCabinetConfig.cabinetConfig;
    const wallxright = inchtopointfactor*currentWall.wallwidth + wallx - (sameConfig?prevCornerCabinetConfig.width:inchtopointfactor*cornerCabinetConfig.widthMin);

    let wallrightcornercab = {... wallleftcornercab};
    wallrightcornercab.x = wallxright;
    wallrightcornercab.width = sameConfig?prevCornerCabinetConfig.width:inchtopointfactor*cornerCabinetConfig.widthMin;
    wallrightcornercab.height = (!sameConfig || (mode===0))?inchtopointfactor*cornerCabinetConfig.allowedHeights[0]:prevCornerCabinetConfig.height;
    wallrightcornercab.shapename = "right_corner";
    wallrightcornercab.cabinetConfig = cornerCabinetConfig.configid;            
    wallrightcornercab.id = (Date.now()+160).toString(); // unique ID
    wallrightcornercab.cornerside = cornerCabinetConfig.cornerside;    
    
    var newAdjacentLeftCorner;
    var newAdjacentRightCorner;
    var newAdjacentWallLeftCorner;
    var newAdjacentWallRightCorner;

    if (updt_left_adjacent_corners) { 
      if (rightcornercab.cabinetConfig.toLowerCase().includes(":br") || rightcornercab.cabinetConfig.toLowerCase().includes(":bl")) {
        newAdjacentLeftCorner = AllCabinetConfigs.find(cabconfig => cabconfig.configid === "AdjacentCornerBaseCabinetLemanL");
      }
      else {
        newAdjacentLeftCorner = AllCabinetConfigs.find(cabconfig => cabconfig.configid === "AdjacentCornerBaseCabinet");
      }

      if (wallrightcornercab.cabinetConfig.toLowerCase().includes(":br") || wallrightcornercab.cabinetConfig.toLowerCase().includes(":bl")) {
        newAdjacentWallLeftCorner = AllCabinetConfigs.find(cabconfig => cabconfig.configid === "AdjacentCornerUpperCabinetFillerPlusDoorL");
      }
      else {
        newAdjacentWallLeftCorner = AllCabinetConfigs.find(cabconfig => cabconfig.configid === "AdjacentCornerUpperCabinet");
      }
      

    }

    if (updt_right_adjacent_corners) {
      if (leftcornercab.cabinetConfig.toLowerCase().includes(":br") || leftcornercab.cabinetConfig.toLowerCase().includes(":bl")) {
        newAdjacentRightCorner = AllCabinetConfigs.find(cabconfig => cabconfig.configid === "AdjacentCornerBaseCabinetLemanR");
      }
      else {
        newAdjacentRightCorner = AllCabinetConfigs.find(cabconfig => cabconfig.configid === "AdjacentCornerBaseCabinet");
      }

      
      if (wallleftcornercab.cabinetConfig.toLowerCase().includes(":br") || wallleftcornercab.cabinetConfig.toLowerCase().includes(":bl")) {
        newAdjacentWallRightCorner = AllCabinetConfigs.find(cabconfig => cabconfig.configid === "AdjacentCornerUpperCabinetFillerPlusDoorR");
      }
      else {
        newAdjacentWallRightCorner = AllCabinetConfigs.find(cabconfig => cabconfig.configid === "AdjacentCornerUpperCabinet");
      }  
      
    }

    const cont = props.onInsertWall(
      currentWall, defaultSide, mode, leftcornercab, rightcornercab, 
      wallleftcornercab, wallrightcornercab, previousBaseLeftCornerWidth, previousWallLeftCornerWidth, //previousWallLeftCornerWidth
      newAdjacentLeftCorner, newAdjacentRightCorner, newAdjacentWallLeftCorner, newAdjacentWallRightCorner
    );

    if (cont) { 
      handleClose();
    }
    else {
      setShowerror(true);
      setErrmessage("Collision detected. Wall not inserted/updated.");
    }

    console.log(currentWall);

  };

  const onChangeLeftCornerEnd = (e) => {
    setLeftCornerEnd(e.target.value);
  };

  const onChangeRightCornerEnd = (e) => {
    setRightCornerEnd(e.target.value);
  }  


  const onChangeWallLeftCornerEnd = (e) => {
    setWallLeftCornerEnd(e.target.value);
  };

  const onChangeWallRightCornerEnd = (e) => {
    setWallRightCornerEnd(e.target.value);
  }    

  ////////////////////////////// TOOLTIPS BEGIN

  const moveleftWallTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Move to the Left Wall
    </Tooltip>
  );  
  /*  
  const leftWallTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Insert Left Wall
    </Tooltip>
  );  

  const rightWallTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Insert Right Wall
    </Tooltip>
  );  

  const moverightWallTooltip = (props) => ( //moverightWallTooltip
    <Tooltip id="button-tooltip" {...props}>
      Move to the Right Wall
    </Tooltip>
  );  
  */ 

  const deleteWallTooltip = (props) => ( //
    <Tooltip id="delete-wall-button-tooltip" {...props}>
      Delete Wall. You cannot undo this.
    </Tooltip>
  );     

  ////////////////////////////// TOOLTIPS END
  // are these useEffects good here?
  // or should they be within handleShow?
  useEffect(() => {
    DisableOrDisableDropdown({ mode, currentWallIndex, wall:props.wall, walls:props.walls });
  },[defaultSide, currentWallIndex]); //// currentWallIndex as well? Yes, currentWallIndex is needed here.

  useEffect(() => {
    //DisableOrDisableDropdown({ mode, currentWallIndex, wall:props.wall });
  },[]);  

  useEffect(() =>{
    if (leftCornerEnd === "NoCornerCabinet" || wallleftCornerEnd === "NoCornerCabinet") {
      setLabelForNoCornerLeftCabinet("Cannot insert wall to the left.");
    }
    else {
      setLabelForNoCornerLeftCabinet("");
    }
  }, [leftCornerEnd, wallleftCornerEnd]);

  useEffect(() =>{
    if (rightCornerEnd === "NoCornerCabinet" || wallrightCornerEnd === "NoCornerCabinet") {
      setLabelForNoCornerRightCabinet("Cannot insert wall to the right.");
    }
    else {
      setLabelForNoCornerRightCabinet("");
    }
  }, [rightCornerEnd, wallrightCornerEnd]);  

  const DisableOrDisableDropdown = (props) => {    
    const mode = props.mode;
    const currentWallIndex = parseInt(props.currentWallIndex);
    const wall = props.wall;
    const walls = props.walls;

    var basecornerToTheSide;
    var wallcornerToTheSide;
    //console.log(props.walls[currentWallIndex]);

    if (mode===0) {
      if (defaultSide === "right") {
        setBaseLeftCornerSelectEnabled(false);
        setWallLeftCornerSelectEnabled(false);
        setBaseRightCornerSelectEnabled(true);
        setWallRightCornerSelectEnabled(true);    
        
        basecornerToTheSide = wall.rectangles.find(rect => rect.shapename === "right_corner");

        console.log(basecornerToTheSide);
        if (basecornerToTheSide.cabinetConfig.toLowerCase().includes(":br") || basecornerToTheSide.cabinetConfig.toLowerCase().includes(":bl")) {
          setLeftCornerEnd("AdjacentCornerBaseCabinetLemanL");
        }
        else {
          setLeftCornerEnd("AdjacentCornerBaseCabinet");
        }

        //setWallLeftCornerEnd("AdjacentCornerUpperCabinet");        
        wallcornerToTheSide = wall.wallrectangles.find(rect => rect.shapename === "right_corner");
        if (wallcornerToTheSide.cabinetConfig.toLowerCase().includes(":br") || wallcornerToTheSide.cabinetConfig.toLowerCase().includes(":bl")) {
          setWallLeftCornerEnd("AdjacentCornerUpperCabinetFillerPlusDoorL");
        }
        else {
          setWallLeftCornerEnd("AdjacentCornerUpperCabinet");
        }
        

        setRightCornerEnd("FillerEndPanel");        
        setWallRightCornerEnd("FillerEndPanel");
      }
      else if (defaultSide === "left") {
        setBaseLeftCornerSelectEnabled(true);
        setWallLeftCornerSelectEnabled(true);        
        setBaseRightCornerSelectEnabled(false);
        setWallRightCornerSelectEnabled(false);

        basecornerToTheSide = wall.rectangles.find(rect => rect.shapename === "left_corner");
        if (basecornerToTheSide.cabinetConfig.toLowerCase().includes(":br") || basecornerToTheSide.cabinetConfig.toLowerCase().includes(":bl")) {
          setRightCornerEnd("AdjacentCornerBaseCabinetLemanR");
        }
        else {
          setRightCornerEnd("AdjacentCornerBaseCabinet");
        }

        //setWallRightCornerEnd("AdjacentCornerUpperCabinet");
        
        wallcornerToTheSide = wall.wallrectangles.find(rect => rect.shapename === "left_corner");
        if (wallcornerToTheSide.cabinetConfig.toLowerCase().includes(":br") || wallcornerToTheSide.cabinetConfig.toLowerCase().includes(":bl")) {
          setWallRightCornerEnd("AdjacentCornerUpperCabinetFillerPlusDoorR");
        }
        else {
          setWallRightCornerEnd("AdjacentCornerUpperCabinet");
        }
        

        setLeftCornerEnd("FillerEndPanel");
        setWallLeftCornerEnd("FillerEndPanel");
      }
    }
    else {
      console.log("xxx");
      console.log(currentWallIndex, zeroIndex);
      console.log(wall);       

      const leftCornerCabinetConfig = wall.rectangles.find(rect => rect.shapename === "left_corner").cabinetConfig;
      const rightCornerCabinetConfig = wall.rectangles.find(rect => rect.shapename === "right_corner").cabinetConfig;
      
      setLeftCornerEnd(leftCornerCabinetConfig);
      setWallLeftCornerEnd(wall.wallrectangles.find(rect => rect.shapename === "left_corner").cabinetConfig);        
      setRightCornerEnd(rightCornerCabinetConfig);
      setWallRightCornerEnd(wall.wallrectangles.find(rect => rect.shapename === "right_corner").cabinetConfig);   
      
      let newAdjacentLeftCorner = {};

      if (currentWallIndex === zeroIndex) { // enable both
        setBaseLeftCornerSelectEnabled(true);
        setWallLeftCornerSelectEnabled(true);
        setBaseRightCornerSelectEnabled(true);
        setWallRightCornerSelectEnabled(true);
        /*
        setRightCornerEnd(wall.rectangles.find(rect => rect.shapename === "right_corner").cabinetConfig);
        setWallRightCornerEnd(wall.wallrectangles.find(rect => rect.shapename === "right_corner").cabinetConfig);                

        setLeftCornerEnd(wall.rectangles.find(rect => rect.shapename === "left_corner").cabinetConfig);
        setWallLeftCornerEnd(wall.wallrectangles.find(rect => rect.shapename === "left_corner").cabinetConfig);  
        */
        console.log(rightCornerCabinetConfig);
      


      }
      else if (currentWallIndex > zeroIndex) { // disable left
        setBaseLeftCornerSelectEnabled(false);
        setWallLeftCornerSelectEnabled(false);
        setBaseRightCornerSelectEnabled(true);
        setWallRightCornerSelectEnabled(true);            
      }
      else if (currentWallIndex < zeroIndex) { // disable right
        setBaseRightCornerSelectEnabled(false);
        setWallRightCornerSelectEnabled(false);
        setBaseLeftCornerSelectEnabled(true);
        setWallLeftCornerSelectEnabled(true);        

        //setLeftCornerEnd(wall.rectangles.find(rect => rect.shapename === "left_corner").cabinetConfig);
        //setWallLeftCornerEnd(wall.wallrectangles.find(rect => rect.shapename === "left_corner").cabinetConfig);        
      }
    }  
  };

  return (
    <>    
      <Button 
        onClick={handleShow} 
        className='ms-1'         
        style={{maxWidth:"70px",maxHeight:'38px'}} 
        variant="primary"
        disabled={((currentWallIndex !== 0) && (currentWallIndex !== totalwalls - 1) &&(mode===0))}
      >
        {mode===0?
          <>
            <GiBrickWall />{" "}<MdAddCircle />            
          </>
        :
          <>
            <GiBrickWall />{" "}<MdEditSquare />
          </>
        }
      </Button>         

      {props.mode===1 &&
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={deleteWallTooltip}>        
          <Button style={{maxWidth:'70px'}} className='ms-1 btn-danger' id="delete-wall" onClick={props.onDeleteWall}>
            <><GiBrickWall/>{" "}<MdDeleteForever/></>
          </Button> 
        </OverlayTrigger>  
      }
      
      
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>

        </Modal.Header>
        <Modal.Body>
          
          <Col>
            <Row style={{display:'flex', flexDirection:'row', gap:0, justifyContent:'flex-start', alignContent:'baseline'}}>   
              <Col className='col-sm-4' style={{maxWidth:200}}>
                <FormLabel htmlFor="todaydate">Wall Height:</FormLabel>
                <FormControl className="form-control"
                  value={currentWall.wallheight ?? ''}
                  onChange={onChangeCurrentWallHeight}
                  type="number"
                  name="wallheight"
                  id="wallheight" />
              </Col>
              <Col className='col-sm-4' style={{maxWidth:200}}>
                <FormLabel className="mr-5" htmlFor="raisedby">Wall Width:</FormLabel>
                <FormControl className="form-control"
                  value={currentWall.wallwidth ?? ''}
                  onChange={onChangeCurrentWallWidth}
                  type="number"
                  name="wallwidth"
                  id="wallwidth" />
              </Col>
              <Col className='col-sm-4' style={{maxWidth:200}}>
                <FormLabel className="mr-5" htmlFor="raisedby">Sofit:</FormLabel>
                <FormControl className="form-control"
                  value={currentWall.wallsoftheight ?? ''}
                  onChange={onChangeCurrentWallSofheight}
                  type="number"
                  name="softHeight"
                  id="softHeight" />
              </Col>  

              <Col className='col-sm-4' style={{maxWidth:200}}>
                <FormLabel className="mr-5" htmlFor="raisedby">Wall Name:</FormLabel>
                <FormControl className="form-control"
                  value={currentWall.wallname ?? ''}
                  onChange={onChangeCurrentWallName}
                  type="text"
                  name="wallName"
                  id="wallName" />                              
              </Col>  

              <Col className='col-sm-2' style={{textAlign:'left',width:'200px'}}>
                <FormLabel>Wall Side</FormLabel>
                <select 
                  disabled={!(mode===0)}
                  value={defaultSide}
                  className="form-control" 
                  id="wall-side" 
                  name="wall-side" 
                  onChange={onChangeCurrentWallSide}
                >
                  {(currentWallIndex ===totalwalls-1) &&
                  <option value={"right"}>{"To the Right of Current Wall"}</option>
                  }
                  {(currentWallIndex===0) &&
                  <option value={"left"}>{"To the Left of Current Wall"}</option>
                  }
                </select>                 
                <Container style={{display:'flex',flexDirection:'row', justifyContent:'left', gap:5, padding:'0'}}>
                
                </Container>                                                              
              </Col>  

              <Col className='col-sm-2' style={{textAlign:'left',width:'200px'}}>
                <FormLabel>Wall Direction</FormLabel>
                <select 
                  disabled={!(mode===0)}
                  value={newWallDirection}
                  className="form-control" 
                  id="wall-direction" 
                  name="wall-direction" 
                  onChange={onChangeCurrentWallDirection}
                >
                  <option value={90}>{"Towards You"}</option>
                  <option value={-90}>{"Away From You"}</option>
                </select>                 
              </Col>                                                                       
            </Row>
          
            <Row>
              <FormLabel className="mt-4">Corners</FormLabel>
            </Row>



            <Row>
              <Col className='col-sm-2' style={{textAlign:'left',width:'200px'}}>
                <FormLabel>Wall Left Corner</FormLabel>
                <select 
                  value={wallleftCornerEnd}
                  //defaultValue={wallleftCornerEnd} 
                  className="form-control" 
                  id="left-corner" 
                  name="left-corner" 
                  onChange={onChangeWallLeftCornerEnd}
                  disabled={!wallLeftCornerSelectEnabled}                                    
                >
                  {/*Names from BaseCabinets.js */}    
                  <ListOfCornerOptions 
                    mode={props.mode}
                    cornerside={"L"}
                    cabtype={"wall_cabinet"}
                    cornerrect={currentWall.wallrectangles?(currentWall.wallrectangles.find(rect => rect.shapename === "left_corner")):{}}
                  />                        
                </select>                 
              </Col>        

              <Col className='col-sm-2' style={{textAlign:'left',width:'200px'}}>
                <FormLabel>Wall Right Corner</FormLabel>
                <select 
                  value={wallrightCornerEnd}
                  //defaultValue={wallrightCornerEnd} 
                  className="form-control" 
                  id="right-corner" 
                  name="right-corner" 
                  onChange={onChangeWallRightCornerEnd}
                  disabled={!wallRightCornerSelectEnabled}                                    
                >
                  <ListOfCornerOptions 
                    mode={props.mode}
                    cornerside={"R"}
                    cabtype={"wall_cabinet"}
                    cornerrect={currentWall.wallrectangles?(currentWall.wallrectangles.find(rect => rect.shapename === "right_corner")):{}}
                  />                                
                </select>                 
              </Col>  
            </Row>    



            <Row className="mt-2">
              <Col className='col-sm-2' style={{textAlign:'left',width:'200px'}}>
                <FormLabel>Base Left Corner</FormLabel>
                <select 
                  value={leftCornerEnd}
                  //defaultValue={leftCornerEnd} 
                  className="form-control" 
                  id="left-corner" 
                  name="left-corner" 
                  onChange={onChangeLeftCornerEnd}
                  disabled={!baseLeftCornerSelectEnabled}                                    
                >                  
                  <ListOfCornerOptions 
                    mode={props.mode}
                    cornerside={"L"}
                    cabtype={"base_cabinet"}
                    cornerrect={currentWall.rectangles?(currentWall.rectangles.find(rect => rect.shapename === "left_corner")):{}}
                  />                            
                </select>                 
              </Col>        

              <Col className='col-sm-2' style={{textAlign:'left',width:'200px'}}>
                <FormLabel>Base Right Corner</FormLabel>
                <select 
                  value={rightCornerEnd}
                  //defaultValue={rightCornerEnd} 
                  className="form-control" 
                  id="right-corner" 
                  name="right-corner" 
                  onChange={onChangeRightCornerEnd}
                  disabled={!baseRightCornerSelectEnabled}                  
                >                   
                  <ListOfCornerOptions 
                    mode={props.mode}
                    cornerside={"R"}
                    cabtype={"base_cabinet"}
                    cornerrect={currentWall.rectangles?(currentWall.rectangles.find(rect => rect.shapename === "right_corner")):{}}
                  />                
                </select>                 
              </Col>  
            </Row>                               

            < hr />

            <Row>
              <span style={{color:"red",fontSize:12}}>{LabelForNoCornerLeftCabinet}</span>
            </Row>   
            <Row>
              <span style={{color:"red",fontSize:12}}>{LabelForNoCornerRightCabinet}</span>
            </Row>                             

            {props.mode===0 &&
            <>
            <Row>            
              <FormLabel>{"The wall with dashed contour will be inserted according to the following layout."}</FormLabel>
            </Row>          

            <Row style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
              <Col className="m-2" style={{backgroundColor:'lightgray',maxWidth:'200px'}}>
              <Stage width={stagewidth} height={stageheight} draggable
                onMouseMove={(e) => {
                  e.target.getStage().container().style.cursor = 'move';
                }}                   
                onMouseLeave={(e) => {
                  e.target.getStage().container().style.cursor = 'default';
                }}                                           
              >
                {/* ------------------------------------------------------------
                    Preview of the insertion. Everything is drawn inside a group
                    that is rotated by the ABSOLUTE orientation of the current
                    wall, so the preview shows exactly what the top view will
                    show. Inside the group the current wall goes to the right and
                    the user ("Towards You") is below it.
                    The old version rotated the layer by an accumulated
                    "sumOfAngles" (negated for left insertions) and anchored the
                    new wall with a table of offsets, which did not match the
                    top view once the design had several walls.
                   ------------------------------------------------------------ */}
                <Layer>
                  <Group
                    x={stagewidth/2}
                    y={stageheight/2}
                    rotation={currentWallAngle}
                  >
                    {/* the current wall: from (-L/2,0) to (L/2,0), body drawn
                        on the side opposite to the room */}
                    <Rect
                      x={-widthttopwallloc/2}
                      y={0}
                      width={widthttopwallloc}
                      height={heighttopwallloc}
                      offset={{x:0, y:heighttopwallloc}}
                      fill={"blue"}
                      stroke="black"
                      strokeWidth={0}
                    />

                    {/* where the user stands when looking at this elevation */}
                    <Arrow
                      points={[0, 34, 0, 8]}
                      stroke="black"
                      strokeWidth={2}
                      fill="black"
                      pointerLength={10}
                      pointerWidth={10}
                      lineJoin="round"
                      lineCap="round"
                    />

                    {/* the new wall. It grows from the selected end of the
                        current wall towards the selected direction. For a wall
                        inserted on the left the chain runs backwards, so the
                        rectangle starts at its far end and is drawn rotated by
                        180 degrees - that is what keeps preview and top view
                        identical. */}
                    <Rect
                      {...previewNewWallRect}
                      fill={"white"}
                      stroke="black"
                      strokeWidth={1}
                      dash={[5, 5]}
                    />
                  </Group>
                </Layer>
              </Stage>  
              </Col>

            </Row>                        
            </>            
            }



          </Col>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={onSaveWall}>Save</Button>
        </Modal.Footer>

        <Container className="row" style={{width:'100vw',margin:'20px'}}>
          <Row className='mt-2'>
            {showerror && (
              <MessageBox show={true} showerror={showerror} errmessage={errmessage}
                onHide={() => {
                  setShowerror(false)
                }}
              />
            )}
            {showsuccess && (

              <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
                onHide={() => {
                setShowsuccess(false);
              }}
              />
            )}
    
          </Row>            
        </Container>        

      </Modal>





    </>
  )

}

const ListOfRoles = (props) => {
  if (!props.roles) {
    return 
  }
  const rows = props.roles.map((row, index) => {
    return (  
      <option key={index} value={row.id}>        
        {row.rolename}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected>
      {"Select"}
    </option>
    {rows}
    </>
  )
}

const ListOfCornerOptions = (props) => {
  const mode = props.mode;
  const cornerside = props.cornerside;
  const cabtype = props.cabtype;
  const cornerrect = props.cornerrect;
  let AllBaseCornerOptions = AllCabinetConfigs.filter(
    config => 
      config.cabtype === cabtype
      && config.configname.toLowerCase().includes("corner")
      && config.cornerside === cornerside
  );  
  const rows = AllBaseCornerOptions.map(basecorneroption => {
    let optionDisabled = basecorneroption.showInTable===undefined?false:!basecorneroption.showInTable;
    // the <select> elements are controlled (value=...), so the options must not
    // carry a `selected` attribute.
    return (
      <option
        key={basecorneroption.configid}
        style={{display:optionDisabled?'none':'block'}}
        value={basecorneroption.configid}
        disabled={optionDisabled}
      >
        {basecorneroption.configname}
      </option>
    )
  });
  return (
    <>
    {rows}
    </>    
  );
};


export default InsertOrEditCurrentWall;